import { render, staticRenderFns } from "./StatusesLog.vue?vue&type=template&id=65bb945c&scoped=true"
import script from "./StatusesLog.vue?vue&type=script&lang=js"
export * from "./StatusesLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb945c",
  null
  
)

export default component.exports